<template>
  <div class="about-us-our-values">
    <PageTitle :title="$t('components.main.navigation.about.us.our-values')" :bordered="true" />
    <Hero
      height="auto"
      :image="{
        height: 400,
        classes: 'tw-object-contain tw-max-w-full tw-h-auto min-[1110px]:tw-h-[400px]',
      }"
      url="/assets/images/our-values/hero_nobg.png"
      background="linear-gradient(to bottom, #fdd4aa, #fff6d2) no-repeat center"
    />
    <div class="tw-grid tw-grid-cols-12 tw-container tw-px-0">
      <div
        class="value-selector tw-flex-row tw-justify-between tw-border-solid tw-border-0 tw-border-b tw-text-zinc-450 tw-border-b-zinc-450 tw-mt-16 tw-px-6 lg:tw-px-0 tw-col-span-12 tw-gap-2 lg:tw-col-span-6 lg:tw-col-start-4 tw-hidden lg:tw-flex"
      >
        <div
          v-for="value in values"
          class="value-name tw-font-semibold tw-text-4 tw-pb-4 tw-text-center cursor-pointer"
          :class="{
            'tw-text-primary tw-border-solid tw-border-0 tw-border-b-2 tw-border-b-primary':
              selectedValue === value.key,
          }"
          @click="selectedValue = value.key"
        >
          {{ $t(`components.our-values.${value.key}`) }}
        </div>
      </div>
      <div class="general-input lg:tw-hidden tw-col-span-12 tw-mt-8 tw-px-6">
        <div class="field field-select">
          <select
            id="value_id"
            v-model="selectedValue"
            type="text"
            name="value_id"
            class="input tw-border-none tw-appearance-none"
            :data-vv-as="$t('components.main.navigation.about.us.our-values')"
          >
            <option
              v-for="value in values"
              :value="value.key"
              :label="$t(`components.our-values.${value.key}`)"
            ></option>
          </select>
          <label for="value_id" data-tid="subject_label">
            {{ $t('components.main.navigation.about.us.our-values') }}
          </label>
        </div>
      </div>
    </div>
    <div class="values xs:tw-grid tw-grid-cols-12 tw-gap-10 tw-mt-10 lg:tw-mt-14 lg:tw-px-0 tw-container tw-px-0">
      <div
        v-for="valueItem in selectedKeyValues"
        class="tw-grid tw-grid-cols-12 tw-col-span-12 tw-px-6 lg:tw-px-0 tw-mb-7.5 xs:tw-mb-0"
      >
        <div
          class="tw-order-1 tw-col-span-12 lg:tw-col-span-2 tw-hidden lg:tw-block"
          :class="{
            'lg:tw-col-start-2 lg:tw-mr-[30px] lg:tw-ml-[-30px]': !valueItem.reverse,
            'lg:tw-col-start-10 lg:tw-order-2 lg:tw-mr-[-30px] lg:tw-ml-[30px]': valueItem.reverse,
          }"
        >
          <nuxt-img
            :src="valueItem.img"
            :alt="valueItem.title"
            width="180"
            height="180"
            loading="lazy"
            class="lg:tw-max-w-full lg:tw-h-auto lg:tw-w-full tw-text-center"
          />
        </div>
        <div
          class="tw-col-span-12 lg:tw-col-span-6 lg:tw-col-start-4 tw-order-2"
          :class="{ 'lg:tw-order-1': valueItem.reverse, 'lg:tw-order-2': !valueItem.reverse }"
        >
          <h2 class="tw-text-7 tw-font-semibold tw-leading-8 tw-hidden lg:tw-block">{{ valueItem.title }}</h2>
          <h4 class="tw-text-5 tw-font-semibold tw-leading-6 tw-block lg:tw-hidden">{{ valueItem.title }}</h4>
          <p class="tw-text-zinc-450 tw-text-14 tw-leading-5">{{ valueItem.content }}</p>
        </div>
      </div>
    </div>

    <div class="px-20 px-md-30 py-30 py-lg-40">
      <div class="new-container mx-auto">
        <div>
          <BottomBanner image-url="/assets/images/airalo-careers/job-vacancies-banner.jpg">
            <div class="display-flex flex-column justify-content-center align-items-center w-100">
              <h2 class="typo-h1 mb-0">
                {{ $t('components.banner.job.vacancies.title') }}
              </h2>
              <p class="typo-p mb-0 mt-10 text-center">
                {{ $t('components.banner.job.vacancies.subtitle') }}
              </p>
              <nuxt-link
                @click.native="
                  sendEventHandler({
                    text: $t('components.banner.job.vacancies.button-title'),
                    url: localePath({ name: 'airalo-careers-working-at-airalo' }),
                  })
                "
                class="button button-secondary btn-primary-hv shadowed minw-224 mt-20 text-center"
                :to="
                  localePath({
                    name: 'airalo-careers-working-at-airalo',
                  })
                "
              >
                {{ $t('components.banner.job.vacancies.button-title') }}
              </nuxt-link>
            </div>
          </BottomBanner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PageTitle from '~/components/shared/page-title.vue'
  import Hero from '~/components/shared/hero'
  import AboutUsContents from '~/components/about-us/contents.vue'
  import TeamsStartupSection from '~/components/about-us/teams-startup-section'
  import BottomBanner from '@/components/bottom/banner.vue'

  export default {
    name: 'about-us-our-values',
    components: {
      BottomBanner,
      PageTitle,
      Hero,
      AboutUsContents,
      TeamsStartupSection,
    },

    data() {
      return {
        values: [
          {
            key: 'ownership',
            data: [
              {
                title: this.$t('components.our-values.ownership.value1'),
                content: this.$t('components.our-values.ownership.description1'),
                img: '/assets/images/our-values/ownership_1.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.ownership.value2'),
                content: this.$t('components.our-values.ownership.description2'),
                img: '/assets/images/our-values/ownership_2.svg',
                reverse: true,
              },
              {
                title: this.$t('components.our-values.ownership.value3'),
                content: this.$t('components.our-values.ownership.description3'),
                img: '/assets/images/our-values/ownership_3.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.ownership.value4'),
                content: this.$t('components.our-values.ownership.description4'),
                img: '/assets/images/our-values/ownership_4.svg',
                reverse: true,
              },
              {
                title: this.$t('components.our-values.ownership.value5'),
                content: this.$t('components.our-values.ownership.description5'),
                img: '/assets/images/our-values/ownership_5.svg',
                reverse: false,
              },
            ],
          },
          {
            key: 'empathy',
            data: [
              {
                title: this.$t('components.our-values.empathy.value1'),
                content: this.$t('components.our-values.empathy.description1'),
                img: '/assets/images/our-values/empathy_1.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.empathy.value2'),
                content: this.$t('components.our-values.empathy.description2'),
                img: '/assets/images/our-values/empathy_2.svg',
                reverse: true,
              },
              {
                title: this.$t('components.our-values.empathy.value3'),
                content: this.$t('components.our-values.empathy.description3'),
                img: '/assets/images/our-values/empathy_3.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.empathy.value4'),
                content: this.$t('components.our-values.empathy.description4'),
                img: '/assets/images/our-values/empathy_4.svg',
                reverse: true,
              },
            ],
          },
          {
            key: 'authenticity',
            data: [
              {
                title: this.$t('components.our-values.authenticity.value1'),
                content: this.$t('components.our-values.authenticity.description1'),
                img: '/assets/images/our-values/authenticity_1.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.authenticity.value2'),
                content: this.$t('components.our-values.authenticity.description2'),
                img: '/assets/images/our-values/authenticity_2.svg',
                reverse: true,
              },
              {
                title: this.$t('components.our-values.authenticity.value3'),
                content: this.$t('components.our-values.authenticity.description3'),
                img: '/assets/images/our-values/authenticity_3.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.authenticity.value4'),
                content: this.$t('components.our-values.authenticity.description4'),
                img: '/assets/images/our-values/authenticity_4.svg',
                reverse: true,
              },
            ],
          },
          {
            key: 'iteration',
            data: [
              {
                title: this.$t('components.our-values.iteration.value1'),
                content: this.$t('components.our-values.iteration.description1'),
                img: '/assets/images/our-values/iteration_1.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.iteration.value2'),
                content: this.$t('components.our-values.iteration.description2'),
                img: '/assets/images/our-values/iteration_2.svg',
                reverse: true,
              },
              {
                title: this.$t('components.our-values.iteration.value3'),
                content: this.$t('components.our-values.iteration.description3'),
                img: '/assets/images/our-values/iteration_3.svg',
                reverse: false,
              },
              {
                title: this.$t('components.our-values.iteration.value4'),
                content: this.$t('components.our-values.iteration.description4'),
                img: '/assets/images/our-values/iteration_4.svg',
                reverse: true,
              },
            ],
          },
        ],
        selectedValue: 'ownership',
      }
    },

    computed: {
      selectedKeyValues() {
        const selectedValueItem = this.values.find((value) => value.key === this.selectedValue)
        return selectedValueItem.data
      },
    },

    head() {
      return {
        title: this.$te('seo.about.us.our-values-title')
          ? this.$t('seo.about.us.our-values-title')
          : this.$t('seo.about.us.about-airalo-title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.about.us.our-values-description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.about.us.our-values-keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.about.us.our-values-title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.about.us.our-values-description'),
          },
        ],
      }
    },
  }
</script>
